// ═════════════════════════════════════════════════════════════════════════════
//  MuroVitrina.jsx
//  LA VITRINA SIGUE ABIERTA PARA QUIEN NO TIENE CUENTA, Y CERRADA PARA QUIEN
//  LA TUVO Y SE QUEDÓ SIN ACCESO
//
//  `/profesores` nació como página de venta: es la primera pantalla de alguien
//  que llega por el enlace de un profesor, y pedirle cuenta antes de dejarle
//  mirar es perder a la mitad de la gente justo donde menos se puede permitir.
//  Por eso está fuera de `ProtectedRoute` y no lleva `SubscriptionGuard`.
//
//  Pero eso dejaba un hueco que Rob vio el 17-09-2026, ya desplegado: «en las
//  pestañas de Profesores no sale, debería salir ahí». Un alumno con la prueba
//  vencida pulsaba «Profesores» en su propio menú y entraba como si nada,
//  mientras el resto del producto le decía que necesita un plan.
//
//  Son dos personas distintas delante de la misma dirección:
//
//    · SIN SESIÓN  → es un visitante. La vitrina es suya, intacta. Aquí no se
//                    le pide nada ni se le espera a nada: se pinta y punto.
//    · CON SESIÓN Y SIN ACCESO → es un cliente que se quedó fuera, y se le
//                    trata como en cualquier otra pantalla: la pared de
//                    reactivación, que además le dice cómo volver.
//    · CON SESIÓN Y CON ACCESO → pasa.
//
//  Mientras se comprueba, a quien TIENE sesión no se le enseña la lista: se
//  deja el hueco en blanco. Enseñar los profesores medio segundo y quitarlos
//  después es exactamente el parpadeo que Rob mandó eliminar del resto del
//  producto.
// ═════════════════════════════════════════════════════════════════════════════

import { Navigate } from 'react-router-dom';
import { useSubscriptionStatus } from './SubscriptionGuard';

export default function MuroVitrina({ children }) {
  // El hook, sin token, se pone en "paused" por seguridad. Aquí eso mandaría a
  // un visitante a una pared que no le corresponde, así que la sesión se mira
  // antes que nada.
  const haySesion = Boolean(
    localStorage.getItem('token') || localStorage.getItem('access_token'),
  );
  const { status, loading } = useSubscriptionStatus();

  if (!haySesion) return children;
  if (loading) return <div style={{ minHeight: '100vh' }} />;
  if (status === 'overdue') return <Navigate to="/reactivar" replace />;

  return children;
}
